/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const listIncidentCustomerOptionsParamsQMax = 100;

export const listIncidentCustomerOptionsParamsLimitDefault = 50;
export const listIncidentCustomerOptionsParamsLimitMax = 50;

export const listIncidentCustomerOptionsParamsCursorMax = 4096;

export const ListIncidentCustomerOptionsParams = zod.object({
  q: zod.string().min(1).max(listIncidentCustomerOptionsParamsQMax),
  limit: zod
    .int()
    .min(1)
    .max(listIncidentCustomerOptionsParamsLimitMax)
    .default(listIncidentCustomerOptionsParamsLimitDefault),
  cursor: zod.string().min(1).max(listIncidentCustomerOptionsParamsCursorMax).optional(),
});

export type ListIncidentCustomerOptionsParams = zod.input<typeof ListIncidentCustomerOptionsParams>;
export type ListIncidentCustomerOptionsParamsOutput = zod.output<
  typeof ListIncidentCustomerOptionsParams
>;
